export var contextToBiEvent = function (context) {
    var domain = context.domain, area = context.area, _a = context.page, numLevels = _a.numLevels, urlChunks = _a.urlChunks, topLevelRoute = _a.topLevelRoute, queryParams = _a.queryParams, iframeUrlList = context.iframeUrlList, metaSiteId = context.metaSiteId, platform = context.platform, parentUrl = context.parentUrl, userId = context.userId, userExperience = context.userExperience, mappingProduct = context.mappingProduct, mappingUrl = context.mappingUrl;
    var queryParamsStringified = Object.keys(queryParams)
        .reduce(function (acc, key) {
        var value = queryParams[key];
        acc += "".concat(key, "=").concat(value, ",");
        return acc;
    }, '')
        .replace(/,\s*$/, '');
    return {
        context_area: area,
        context_domain: domain,
        context_iframeurllist: iframeUrlList.join(','),
        context_msid: metaSiteId,
        context_uuid: userId,
        context_platform: platform,
        context_parenturl: parentUrl,
        context_page_numlevels: numLevels,
        context_page_queryparams: queryParamsStringified,
        context_page_toplevelroute: topLevelRoute,
        context_page_urlchunks: urlChunks.join(','),
        mapping_url: mappingUrl,
        mapping_product: mappingProduct,
        user_experience: userExperience,
    };
};
export var ChatbotView;
(function (ChatbotView) {
    ChatbotView["helpWidgetContactPage"] = "helpWidgetContactPage";
    ChatbotView["helpWidgetFloating"] = "helpWidgetFloating";
    ChatbotView["editor"] = "editor";
})(ChatbotView || (ChatbotView = {}));
var FULL_PAGE_HC_ROUTE = 'widget';
export var getChatbotView = function (context) {
    if (!(context === null || context === void 0 ? void 0 : context.page)) {
        return null;
    }
    if (context.area === 'editor') {
        return ChatbotView.editor;
    }
    var helpCenterIframe = context.page.numLevels === 2 &&
        context.page.urlChunks.includes(FULL_PAGE_HC_ROUTE);
    if (helpCenterIframe || context.page.numLevels === 1) {
        return ChatbotView.helpWidgetContactPage;
    }
    return ChatbotView.helpWidgetFloating;
};
//# sourceMappingURL=contextToBiEvent.js.map